module.exports = __webpack_public_path__ + "static/media/pattern2.34852976.svg";